import { render, staticRenderFns } from "./CostSubtotalEditor.vue?vue&type=template&id=459e52f5"
import script from "./CostSubtotalEditor.vue?vue&type=script&lang=ts"
export * from "./CostSubtotalEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports